const AI_IMPORT_PPT_PDF = 'AI Import'
const IMPORT_PPT_PDF = 'Import'
const UPLOAD_AUDIO = 'Upload audio'
const UPLOAD_IMAGE = 'Upload image'
const IMPORT_SPREADSHEET = 'Import spreadsheet'
const AUDIENCE_AUTHENTICATION = 'Audience authentication'

export default {
  AI_IMPORT_PPT_PDF,
  IMPORT_PPT_PDF,
  UPLOAD_AUDIO,
  UPLOAD_IMAGE,
  IMPORT_SPREADSHEET,
  AUDIENCE_AUTHENTICATION,
}
